var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5854 6.37099C14.6387 6.64902 14.6666 6.9369 14.6666 7.23175C14.6666 7.23174 14.6666 7.23176 14.6666 7.23175C14.6666 12.4645 10.219 14.924 8.5893 15.6495C8.20967 15.8185 7.79029 15.8185 7.41066 15.6495C7.20694 15.5588 6.9592 15.441 6.68162 15.2941C4.73854 14.2658 1.33331 11.8105 1.33331 7.23181C1.33331 4.87299 3.12417 2.96072 5.33331 2.96072C6.35779 2.96072 7.2923 3.37195 7.99998 4.04826C8.70766 3.37195 9.64217 2.96072 10.6666 2.96072C11.5299 2.96072 12.3293 3.25271 12.9829 3.74924C13.7929 4.36454 14.379 5.29392 14.5854 6.37099Z",
    fill: "#FF2E6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.3f93e3e8.svg";
export { ForwardRef as ReactComponent };